import locationService from '../../../services/supplier/location'
import LocationImport from './LocationImport'
export default {
    components: {
        LocationImport
    },
    data() {
        return {
            total: 0,
            items: [],
            searchQuery: {},
            header: [
                {
                    label: 'Status',
                    name: 'status',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'File Name',
                    name: 'file_name',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Total Rows',
                    name: 'total_rows',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Uploaded By',
                    name: 'created_datetime',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left'
                },
                {
                    label: '',
                    name: 'action',
                    row_text_alignment: 'text-center',
                    column_text_alignment: 'text-center'
                }
            ],
            locationImportKey: 0,
        }
    },
    methods: {
        fetchDelay() {
            this.$refs.table.fetchDelay()
        },
        fetchData() {
            locationService.findLocationFile({
                ...this.searchQuery,
                sortField: this.searchQuery.sort[0] ? this.searchQuery.sort[0].name : null,
                sortDirection: this.searchQuery.sort[0] ? this.searchQuery.sort[0].order : null,
                ...this.search
            }).then(resp=>{
                if(!resp.error) {
                    this.items = resp.data.d.c
                    this.total = resp.data.d.t
                }
            })
        },
        download (item) {
            locationService.getLocationFile(item.id).then(resp=>{
                if(!resp.error) {
                    this.openExternalLink(resp.data.d.data)
                }
            })
        },
        importFile() {
            this.locationImportKey += 1
            this.$nextTick(() => {
                this.$refs.locationImport.forceRerenderInsert()
            })
        },
        onCompleted(type) {
            if (type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            this.fetchData()
        },
    }
}